export default function VerifiedShieldIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M18.7134 4.85001C18.7046 4.71039 18.6491 4.57777 18.556 4.47338C18.4629 4.36899 18.3374 4.29886 18.1997 4.27422C14.8208 3.66797 13.4103 3.22969 10.2571 1.80547C10.1762 1.76891 10.0885 1.75 9.99971 1.75C9.91094 1.75 9.82318 1.76891 9.74229 1.80547C6.58917 3.22969 5.17862 3.66797 1.79971 4.27422C1.662 4.29886 1.53654 4.36899 1.44341 4.47338C1.35028 4.57777 1.29487 4.71039 1.28604 4.85001C1.13565 7.23711 1.45635 9.46133 2.24034 11.4609C2.88234 13.092 3.83245 14.5841 5.03877 15.8559C7.12745 18.0719 9.34503 19.0344 9.76807 19.2047C9.9184 19.2655 10.0865 19.2655 10.2368 19.2047C10.6599 19.0344 12.8774 18.0719 14.9661 15.8559C16.1705 14.5837 17.1187 13.0916 17.7591 11.4609C18.5431 9.46133 18.8638 7.23711 18.7134 4.85001ZM13.5962 7.78399L9.26807 12.784C9.21242 12.8485 9.14418 12.9009 9.06753 12.938C8.99089 12.9752 8.90746 12.9963 8.82237 13H8.79659C8.63301 13 8.47594 12.936 8.35909 12.8215L6.43721 10.9387C6.37858 10.8812 6.33184 10.8128 6.29965 10.7373C6.26747 10.6617 6.25047 10.5806 6.24964 10.4985C6.24796 10.3328 6.3122 10.1731 6.42823 10.0547C6.54426 9.93628 6.70258 9.86881 6.86836 9.86712C7.03414 9.86544 7.1938 9.92968 7.31221 10.0457L8.75752 11.4633L12.6521 6.96602C12.7605 6.84066 12.9143 6.76353 13.0797 6.75159C13.245 6.73965 13.4083 6.79388 13.5337 6.90235C13.6591 7.01082 13.7362 7.16464 13.7481 7.32998C13.7601 7.49532 13.7058 7.65863 13.5974 7.78399H13.5962Z"
        fill="#1E7A1E"
      />
    </svg>
  );
}
